import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import HubspotForm from "react-hubspot-form";
import Skeleton from "@material-ui/lab/Skeleton";
import { firebaseAuthFunc } from "../../config/firebaseAuth";
import { firebaseFireStore } from "../../config/firebaseFirestore";
import { addDoc, collection } from "firebase/firestore/lite";

export default function ContactContainer() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const submitData = async (event) => {
    // event.preventDefault();
    let currentuser = firebaseAuthFunc.currentUser;

    if (!currentuser) {
      renderAlert();
      setAlertMessage({
        success: false,
        message: "You need to sign in, Please sign in first.",
      });
    }

    const data = {
      name,
      email,
      message,
    };
    if (name && email && message && currentuser) {
      await addDoc(collection(firebaseFireStore, "contacts"), {
        ...data,
        userId: currentuser.uid,
      })
        .then(() => {
          setAlertMessage({
            success: true,
            message:
              "Your message has been successfully sent. We will contact you soon!",
          });
          renderAlert();
        })
        .catch((e) => {
          console.log(e, "ERROR");
        });
    }
    // e.target.reset();
    return false
  };

  const renderAlert = () => {
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  return (
    <>
      <section
        className=""
        style={{
          background: "#FFF",
        }}
      >
        <div
          className="collection_main_box py-20"
          style={{
            background: "#f69b07",
            height: "auto",
          }}
        >
          <div className="px-4 md:px-10 w-full collection_main_box_container container mx-auto">
            <div className="">
              <div className="flex flex-wrap text-center justify-center">
                <div className="w-full lg:w-6/12 px-4">
                  <h1 className="head__text text-4xl font-semibold text-white collection_main_heading">
                    Contact Us
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container" style={{ paddingBottom: 0 }}>
          <div className="row w-full" style={{ margin: "auto" }}>
            <div className="flex-auto lg:px-10 py-10 pt-8  mt-12">
              <div>
                <HubspotForm
                  portalId="20283877"
                  formId="cafa64a1-77ac-4e77-82f1-9e2e994bd405"
                  onSubmit={submitData}
                  // onReady={(form) => console.log("Form ready!")}
                  onReady={() => {
                    const script = document.createElement('script');
                    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
                    let jqueryScript = document.getElementsByTagName('script');
                    let src = Array.from(jqueryScript).filter(item => item.src === script.src)
                    if(src.length === 0) {
                      document.body.appendChild(script)
                    }
                  }}
                  loading={
                    <div>
                      <div
                        className="flex 	w-full my-6 mx-6"
                        style={{ flexDirection: "column" }}
                      >
                        <Skeleton animation="wave" height={20} width="60%" />
                        <Skeleton animation="wave" height={20} width="60%" />
                        <Skeleton animation="wave" height={20} width="60%" />
                      </div>
                    </div>
                  }
                  locale="en"
                  translations={{
                    en: {
                      phoneInvalidCharacters:
                        "Must contain only numbers, +, (, ), -, ., and x",
                      missingRequiredFields: " ",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
